import { FC } from 'react';
import { useIntl } from 'react-intl';

import { useStyles } from './simulator.styles';
import { SimulatorProps } from './simulator.models';
import { SimulatorTabs } from './tabs/simulator-tabs';
import { SimulatorHint } from './hint/hint';
import { BackButton } from '../back-button-new';

export const Simulator: FC<SimulatorProps> = ({
  tabs, hint, title, isBackButton = true,
}) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <div className={classes.root}>
      <div className={classes.titleWrapper}>
        {isBackButton && <BackButton />}
        <h1 className={classes.title}>{intl.formatMessage({ id: 'simulator.title.main' || title })}</h1>
      </div>
      <div className={classes.wrapper}>
        <SimulatorTabs tabs={tabs} />
        <SimulatorHint text={hint} />
      </div>
    </div>
  );
};
